import { smoothScrollTo } from "../utilities";

document.addEventListener("DOMContentLoaded", () => {
    const isIX = document.querySelector(".page-template-ix");
    if (!isIX) return;

    const handleProductChange = (productIndex, selectors) => {
        document.querySelectorAll(".x-models .active").forEach((el) => el.classList.remove("active"));
        document.querySelector(`.x-models__model--${productIndex}`).classList.add("active");

        selectors.forEach((selector) => {
            document.querySelectorAll(`${selector}--${productIndex}`).forEach((el) => el.classList.add("active"));
        });
    };

    const listenSlideChange = (selectors) => {
        selectors.forEach((selector) => {
            document.querySelectorAll(selector) &&
                document.querySelectorAll(selector).forEach((btn) => {
                    btn.addEventListener("click", () => {
                        const productIndex = btn.dataset.slide;
                        handleProductChange(productIndex, selectors);
                    });
                });
        });
    };

    listenSlideChange([".x-models__button"]);

    // color Change
    document.querySelectorAll(".x-models__model") &&
        document.querySelectorAll(".x-models__model").forEach((model) => {
            const colorGroups = model.querySelectorAll(".x-models__model-color-selector");
            colorGroups &&
                colorGroups.forEach((colorGroup) => {
                    const colors = colorGroup.querySelectorAll(".x-models__model-color-icon");
                    colors.forEach((color) => {
                        color.addEventListener("click", () => {
                            const colorIndex = color.dataset.color;
                            model.querySelectorAll(".active-color").forEach((el) => el.classList.remove("active-color"));
                            model.querySelector(`.x-models__color-image--${colorIndex}`).classList.add("active-color");
                            model.querySelector(`.x-models__model-color-label--${colorIndex}`).classList.add("active-color");
                            color.classList.add("active-color");
                        });
                    });
                });
        });

    // scroll into view
    const xModelsButtons = document.querySelector(".x-models__buttons");
    document.querySelectorAll(".x-models__bottom-button").forEach((btn) => btn.addEventListener("click", () => smoothScrollTo(xModelsButtons)));
});
